/* globals google */
'use strict';

const storesMap = require('./storesMap');
const isJilSander = document.querySelector('body').classList.contains('JilSander');

module.exports = {
    init: function() {
        const hasMapApi = $('.map-canvas').data('has-google-api');
        const hasResults = $('.results').data('has-results');

        if (hasMapApi) {
            storesMap.init();
        } else {
            $('.store-locator-no-api-key').show();
        }
    },
    detectLocation: function() {
        const $location = $('.detect-location');
        $location.on('click', function() {
            if ($(this).attr('disabled')) return;
            storesMap.geoLocation($location);

            // Tealium event "Find my Location"
            $('body').trigger('store:MyLocation');
        });
    },
    filterStores: function() {
      $('.filter-stores-by-brand').click((e) => {
        e.preventDefault();
        $('.filter-stores-by-brand').removeClass('selected');
        $(e.target).addClass('selected');
        storesMap.filterStoresByBrand();
      });

      if (isJilSander) {
        var $form = $('.fields-form');
        $form.submit(function(e) {
          e.preventDefault();
          $.ajax({
            url: $form.attr('action'),
            type: 'get',
            data: $form.serialize(),
            dataType: 'json',
            success: (data) => {
              storesMap.updateResults({ stores: data });
            },
          });
        });

        $('.filter-stores-by-country').click((e) => {
          e.preventDefault();
          $('.filter-stores-by-country').removeClass('selected');
          $(e.target).addClass('selected');
          storesMap.filterStoresByCountry();
        });

        $('.reset-filter-stores-by-country').click((e) => {
          e.preventDefault();
          $('.page-storelocator-landing').removeClass('country');
          $('.store-locator-result-area').addClass('d-none');
          // $('.page-storelocator-landing').removeClass('-stores-result-wrapper');
          $('.page--storefinder-landing').removeClass('-stores-result-wrapper');
          const $parent = $('.results-length-target').parent();
          const $contents = $parent.contents();
          $contents[$contents.length - 1].nodeValue = $parent.attr('data-text');
          $('.results').empty();
        });
        $('.reset-stores').click((e) => {
          $('.postal-code.form-control.pac-target-input')[0].value = "";
          $('.store-locator-result-area').addClass('d-none');
          $('.reset-stores').addClass('d-none');
        });
      }
    },
    search: function() {
        $('.btn-storelocator-search').click((e) => {
            e.preventDefault();

            if ($('.store-locator-canvas-container').hasClass('layout-split')) {
                $('.fields-header-group .title-fields').addClass('scale-out');
                $('.fields-header-group .form-group').addClass('active');

                const $form = $('.store-locator-fields-layer .form-control');

                if ($form.val() === '') {
                    $form.trigger('focus');
                } else {
                    storesMap.handleSearchEvents();
                }
            } else {
                storesMap.handleSearchEvents();
            }
        });
        $('#store-postal-code').on('keydown', function(e) {
          $('.reset-stores').removeClass('d-none');
        });
    },
    favorite: function() {
        $('body').on('click', '.mark-as-favorite', function(e) {
            e.preventDefault();
            const $btn = $(this);
            const url = $(this).attr('href');
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: (data) => {
                    if (data.status) {
                        $('.mark-as-favorite .icon').addClass('icon-star').removeClass('icon-star-fill');

                        if (data.status === 'added') {
                            $btn.find('.icon').addClass('icon-star-fill');
                            $(`[data-store-id="${data.queryString.replace('sid=', '')}"]`).find('.icon-star').addClass('icon-star-fill');
                        }
                    }
                }
            });
        });
    },
    moreInfo: function () {
      $('body').on('click', '.more-info-content button.more-info', function (e) {
        e.preventDefault();
        $(this).closest('.more-info-content').toggleClass('is-active');
      })
    }
};